

































































































































interface Periods {
    isaccounted: number;
    month: null | number | string;
    period: null | number | string;
    periodStr: null | number | string;
    visable: number;
    year: string;
}
import { Component, Vue } from "vue-property-decorator";
import { DatePickerOptions } from "element-ui/types/date-picker";

import { mapGetters } from "vuex";
import ChooseSubjectVue from "../components/ChooseSubject.vue";
import SubsidiaryLedgerVue from "./SubsidiaryLedger.vue";
import version from "@/version";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "choose-subject": ChooseSubjectVue,
        "subsisiary-dialog": SubsidiaryLedgerVue
    }
})
export default class GeneralLedger extends Vue {
    yearValue: Date = new Date();
    tableData: GeneralBalance[] = [];
    iconIndex: number | null = null; //icon的index
    // pickerOptions初值为空对象,因为还未获取到限制的时间
    pickerOptions: DatePickerOptions = {};

    mounted() {
        this.getPeriods();
    }
    // 获取使时间
    getPeriods() {
        let url = `periods/${this.$store.state.accountBook.id}/find`;
        Vue.axios.post(url, {}).then(res => {
            let date = new Date(res.data[res.data.length - 1].year);
            this.yearValue = date;
            this.pickerOptions = {
                disabledDate: time => {
                    let start: number = new Date(res.data[0].year).getTime();
                    let end: number = new Date(
                        res.data[res.data.length - 1].year
                    ).getTime();
                    return time.getTime() < start || time.getTime() > end;
                }
            };
        });
    }

    // 获取表格数据
    fetchData() {
        if (this.subjectVal) {
            Vue.axios
                .post(`balance/find`, {
                    accountBookId: this.$store.state.accountBook.id,
                    subjectId: this.subjectVal.id,
                    year: this.yearValue.getFullYear()
                })
                .then(res => {
                    this.tableData = res.data;
                });
        }
    }

    // 改变科目数据
    subjectVal: Subject.Subject | null = null; //选中的科目
    changeSubject(val: Subject.Subject) {
        this.subjectVal = val;
        this.fetchData();
    }

    // 是否展示查看明细帐的icon
    showIcon(i: number) {
        this.iconIndex = i;
    }
    offIcon() {
        this.iconIndex = null;
    }

    // 明细账
    showSubsidiary: boolean = false; //是否展示明细帐
    subsidiaryDate: Date[] = []; //明细账月份
    showSub(year: string) {
        let date = new Date(year);
        this.subsidiaryDate = [date, date];
        this.showSubsidiary = true;
    }
    // 下载
    mainDownload() {
        let url = `${Vue.axios.defaults.baseURL}export/pdf/generalledger/all?accountBookId=${this.$store.state.accountBook.id}&startPeriod=${this.yearValue.getFullYear()}&version=${version}&token=${this.$store.state.account.token}`;
        this.$store.dispatch("toggleDownload", true);
        this.$utils.sendToElectron("download", url);
    }
    // 本地下载
    pageDownload() {
        if (this.subjectVal) {
            let url = `${Vue.axios.defaults.baseURL}export/generalledger?accountBookId=${this.$store.state.accountBook.id}&subjectId=${this.subjectVal.id}&startPeriod=${this.yearValue.getFullYear()}&version=${version}&token=${this.$store.state.account.token}`;
            this.$store.dispatch("toggleDownload", true);
            this.$utils.sendToElectron("download", url);
        }
    }
}
